import { render, staticRenderFns } from "./TabSection.vue?vue&type=template&id=219342b2&scoped=true"
import script from "./TabSection.vue?vue&type=script&lang=js"
export * from "./TabSection.vue?vue&type=script&lang=js"
import style0 from "./TabSection.vue?vue&type=style&index=0&id=219342b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219342b2",
  null
  
)

export default component.exports